/**
 * Modules
 */

/**
 * Expose isFunction
 */

module.exports = isFunction['default'] = isFunction

/**
 * isFunction
 */

function isFunction (value) {
  return typeof value === 'function'
}



//////////////////
// WEBPACK FOOTER
// ../~/@f/is-function/lib/index.js
// module id = 570
// module chunks = 0